import React, { FC, useRef } from 'react';
import { Tabs, TextLink, Pagination, Button, Image } from '@bfe/moly';
import { useMarket } from '@/store/market';
import { List } from './List';
import { useI18n } from '@spot-fe/base-ui';
import { useNav } from '@/app/biz';
import { Block } from '@/components/Layout';
import { usePagination } from '@/hooks/pagination'
import {
  AvailableCoinsClick,
  PastCoinsClick,
  MyOrderClick,
} from '@/config/sensor';


import styles from './index.module.scss';

export const ListContent: FC = () => {
  const { t } = useI18n();
  const marketStore = useMarket();
  const indicateWrap = useRef<HTMLInputElement>(null)
  const tabName = marketStore.currentTabName
  const getList = tabName === '1' ? marketStore.tokenListAvaliable : marketStore.tokenListPast
  const pagination = usePagination(getList.length);
  const { navToOrders } = useNav();
  const paginationProps = {
    total: pagination.total,
    pageSize: pagination.pageSize,
    current: pagination.current,
    onChange: (info) => {
      if (indicateWrap?.current) {
        setTimeout(() => {
          indicateWrap?.current!.scrollIntoView()
        }, 320)
      }
      pagination.setPage(info)
    }
  }

  const showList = getList.slice(pagination.start, pagination.end);

  const callTabs = (e) => {
    if (e) {
      pagination.setPage(1)
      marketStore.setCurrentTabName(e)
      if (e === '1') {
        AvailableCoinsClick()
        marketStore.fetchTokenListAvaliable()
      } else {
        PastCoinsClick()
        marketStore.fetchTokenListPast()
      }
    }
  }

  const linkMyOrder = () => {
    MyOrderClick()
    navToOrders(true)
  }

  const items = [
    {
      key: '1',
      label: <p className={`${styles.tabName} ${tabName === '1' ? styles.tabsActive : ''}`}>{t('availableCoins')}</p>,
    },
    {
      key: '2',
      label: <p className={`${styles.tabName} ${tabName === '2' ? styles.tabsActive : ''} `}>{t('pastCoins')}</p>,
    },
  ];
  return (
    <Block
      bgColor="#000"
    >
      <div className={styles.tabList} >
        <div ref={indicateWrap} />
        <section className={styles.tabWrap}>
          <Tabs items={items} defaultActiveKey={tabName} onChange={callTabs} />
          <div>
            <Button variant="secondaryBrand" size="small">
              <TextLink
                variant="primary"
                size="normal"
                onClick={linkMyOrder}
                opensWindow
              >{t('myOrders')}</TextLink>
            </Button>
          </div>
        </section>
        <div className={styles.line}></div>
        {
          !showList?.length ?
            <section className={styles.emptys}>
              <Image className={styles.img} src="https://s1.bycsi.com/bybit/deadpool/image-18fa532793874e8d892a4759aabe4ccb.svg" />
              <p className={styles.text}>{t('noRecordsFound')}</p>
            </section> :
            <>
              <List showList={showList} />
            </>
        }
        {getList.length > 10 && <div className={styles.paginations}>
          <Pagination
            align="right"
            {...paginationProps}
          />
        </div>}
      </div>
    </Block >
  );
};
